import Vue from "vue";
import CONFIG from "./../../config.js";

let actions = {
  getOperatorsAndRegions(context, type) {
    context.commit("addLog", { request: "getOperatorsAndRegions" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(CONFIG.getEndpoint("getOperatorsAndRegions", type), {
          withCredentials: true,
          xsrfCookieName: "SSO_TOKEN"
        })
        .then(response => {
          resolve(response);
          context.commit("set_operator", response.data.operators);
          context.commit("set_region", response.data.regions);
          context.commit("removeLog", { request: "getOperatorsAndRegions" });
        })
        .catch(err => {
          reject(err);
          context.commit("removeLog", { request: "getOperatorsAndRegions" });
        });
    });
  },
  getCustomerRechargeHistory(context) {
    context.commit("addLog", { request: "getCustomerRechargeHistory" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(CONFIG.getEndpoint("getCustomerRechargeHistory"), {
          withCredentials: true,
          xsrfCookieName: "SSO_TOKEN"
        })
        .then(response => {
          resolve(response);
          context.commit("removeLog", {
            request: "getCustomerRechargeHistory"
          });
        })
        .catch(err => {
          reject(err);
          context.commit("removeLog", {
            request: "getCustomerRechargeHistory"
          });
        });
    });
  },
  getPlans(context, params) {
    // console.log(params)
    context.commit("addLog", { request: "getPlans" });

    Vue.axios
      .get(
        `${CONFIG.getEndpoint("getPlans", params.type)}?operator=${
          params.operator
        }&region=${params.region}`,
        {
          withCredentials: true,
          xsrfCookieName: "SSO_TOKEN"
        }
      )
      .then(response => {
        context.commit("removeLog", { request: "getPlans" });
        context.commit("set_plans", response.data.plans);
        context.commit("set_plan_categories", response.data.categories);
      })
      .catch(() => {
        context.commit("removeLog", { request: "getPlans" });
      });
  },
  purchaseInsurance(context, params) {
    return new Promise((resolve, reject) => {
      context.commit("addLog", { request: "purchaseInsurance" });
      Vue.axios
        .put(CONFIG.getEndpoint("purchase_insurance"), params, {
          withCredentials: true
        })
        .then(response => {
          context.commit("removeLog", { request: "purchaseInsurance" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "getPlans" });
          reject(err);
        });
    });
    // console.log(params)
  },
  filterPlans(context, params) {
    context.commit("filter_plans", params);
  },
  setRechargeAmount(context, params) {
    context.commit("set_recharge_amount", params);
  },
  setRechargeOperator(context, params) {
    context.commit("set_recharge_operator", params);
  },
  setRechargeRegion(context, params) {
    context.commit("set_recharge_region", params);
  },
  setRechargeAccountId(context, params) {
    context.commit("set_recharge_account_id", params);
  },
  selectPlan(context, params) {
    context.commit("set_selected_plan", params);
  },
  selectCategory(context, params) {
    context.commit("filter_plans", params);
    context.commit("set_selected_category", params);
  },
  doRecharge(context, params) {
    context.commit("addLog", { request: "doRecharge" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint("doRecharge", params.type), params.params, {
          withCredentials: true,
          xsrfCookieName: "SSO_TOKEN"
        })
        .then(response => {
          if (response.data.responseCode + "" !== "0") {
            const params = { transId: response.data.eplTransactionRefNumber };
            poll(15000, 5000, context, params)
              .then(response => {
                resolve(response);
                context.commit("removeLog", { request: "doRecharge" });
              })
              .catch(err => {
                reject(err);
                context.commit("removeLog", { request: "doRecharge" });
              });
          } else {
            context.commit("removeLog", { request: "doRecharge" });
            resolve(response.data);
          }
        })
        .catch(err => {
          context.commit("removeLog", { request: "doRecharge" });
          if (err.response) {
            reject(err);
          } else {
            resolve({
              responseMessage: "pending",
              responseCode: -10
            });
          }
        });
    });
  },
  checkRechargeStatus(context, params) {
    context.commit("addLog", { request: "checkRechargeStatus" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(CONFIG.getEndpoint("checkRechargeStatus"), {
          withCredentials: true,
          xsrfCookieName: "SSO_TOKEN",
          params
        })
        .then(response => {
          context.commit("removeLog", { request: "checkRechargeStatus" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "checkRechargeStatus" });
          reject(err);
        });
    });
  }
};

export default actions;
function poll(timeout, interval = 100, context, params) {
  let endTime = Number(new Date()) + (timeout || 5000);
  // console.log(context);
  let checkCondition = (resolve, reject) => {
    context
      .dispatch("checkRechargeStatus", params)
      .then(response => {
        if (response.responseCode + "" !== "-10") {
          resolve(response);
        } else if (Number(new Date()) < endTime) {
          setTimeout(checkCondition, interval, resolve, reject);
        } else {
          resolve(response);
        }
      })
      .catch(error => reject(error));
  };
  return new Promise(checkCondition);
}



// WEBPACK FOOTER //
// ./src/store/recharge/actions.js